/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Sanction_BtnInputs */



/**
* | output |
* | --- |
* | "Sanction" |
*
* @param {Players_Sanction_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_sanction_btn = /** @type {((inputs?: Players_Sanction_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Sanction_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sanction")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sanción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sanção")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sanzione")
	return /** @type {LocalizedString} */ ("Sanction")
});